import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { classNames } from "../../helpers/classNames";

const Backdrop = ({ onClick }) => (
  <motion.div
    className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[9980]"
    onClick={onClick}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.25 }}
  />
);

const BottomSheetModal = ({ isOpen, onClose, children, bgclass }) => {
  useEffect(() => {
    if (isOpen) document.body.classList.add("overflow-hidden");
    else document.body.classList.remove("overflow-hidden");
  }, [isOpen]);

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <Backdrop onClick={onClose} />

          <motion.div
            className={classNames(
              "fixed bottom-0 left-0 right-0 z-[9999] bg-white rounded-t-2xl shadow-xl p-5 pb-8",
              bgclass
            )}
            initial={{ y: "100%", scale: 1.01 }}
            animate={{ y: 0, scale: 1 }}
            exit={{ y: "100%", scale: 1.01 }}
            transition={{ type: "tween", duration: 0.3, ease: "easeOut" }}
            drag="y"
            dragElastic={0.2}
            dragConstraints={{ top: 0, bottom: 0 }}
            onDragEnd={(e, info) => {
              if (info.offset.y > 100) onClose();
            }}
          >
            <div className="w-10 h-1 bg-gray-300 rounded-full mx-auto mb-2 mt-2" />
            {children}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default BottomSheetModal;
